import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.purple3};
  background: ${({ theme }) => theme.colors.purple1};
`;
